import { MagpieConnection } from 'magpie-lib/connection';
import { AudienceFilter } from 'magpie-lib/models';
import { useEffect } from 'react';
import { useEffectEvent } from '../hooks/useEffectEvent';
export const useMagpieTopic = ({
  topic,
  message,
  onMessage
}) => {
  const skip = !onMessage;
  const stableOnMessage = useEffectEvent(onMessage);
  useEffect(() => {
    if (skip) {
      return;
    }
    const unsubscribe = MagpieConnection.get().useTopic(topic).on(message.getType(), stableOnMessage);
    return () => unsubscribe();
  }, [message, skip, stableOnMessage, topic]);
};
export const CollaborationSidebarAudience = AudienceFilter.builder().build();